// @flow

/**
 * Module dependencies.
 */

import { get } from 'lodash';
import ReactGA from 'react-ga';
import config from 'config';

/**
 * Analytics tracking id.
 */

const analyticsTrackingId = get(config, 'analytics.trackingId');

/**
 * Initialize google analytics.
 */

function initialize() {
  if (!analyticsTrackingId) {
    return;
  }

  ReactGA.initialize(analyticsTrackingId);
}

/**
 * Send page info to Google Analytics.
 */

function sendPage() {
  const page = window.location.pathname;

  if (!analyticsTrackingId) {
    return;
  }

  ReactGA.set({ page });
  ReactGA.pageview(page);
}

/**
 * Export `googleAnalytics`.
 */

export const googleAnalytics = {
  initialize,
  sendPage
};



// WEBPACK FOOTER //
// ../src/client/core/utils/google-analytics.js